<template>
<div>
  <template>
  <div class="busCampaignEditor">
    <div class="busCampaignEditor__header">
      <div class="busCampaignEditor__header--left">
        <h2 class="large-title">Campaign Editor</h2>
        <p>Set your campaign details</p>
      </div>
    </div>
    <div v-if="isLoadingAll && model.id == null" class="busCampaignEditor__loading">
      <adx-loading slot="loading" />
    </div>
    <div v-if="!isLoadingAll" :class="['busCampaignEditor__content', saveLoading ? 'disabledWrapper' : '']">
      <div :class="['busCampaignEditor__content--left', saveLoading ? 'disabled' : '']">
        <div class="busCampaignEditor__content--section">
          <div class="busCampaignEditor__content__row">
            <adx-input label="Campaign Name" :value.sync="model.campaignInput" :validation="['NotEmpty','NewMinLength:3', 'NewMaxLength:50']" :error.sync="errors.campaignInput" :ref="dataRef.campaignInput" />
          </div>
          <div class="busCampaignEditor__content__row">
            <div class="busCampaignEditor__content__row__left">
              <adx-select-dropdown label="Period of Campaign" :value.sync="model.periodDropdown" :options="periodOptions" :error.sync="errors.periodDropdown"
              :key="rendererPeriod" :ref="dataRef.periodDropdown"/>
            </div>
            <div class="busCampaignEditor__content__row__right">
              <div class="calendar">
                <label>Start Date</label>
                <v-date-picker
                  v-model='model.startInput'
                  :min-date='aWeekLater'
                  :popoverVisibility="'focus'"
                  class='date-input'>
                  <input
                    class="calendar-start"
                    placeholder= "DD/MM/YYYY"
                    type='text'
                    slot-scope='{ inputValue, updateValue }'
                    :value='inputValue'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                </v-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="busCampaignEditor__content--section">
          <div class="title subhead">Contact Information</div>
          <div class="busCampaignEditor__content__row">
            <adx-input label="Company Name *" :value.sync="model.companyInput" :validation="['NotEmpty','NewMinLength:2', 'NewMaxLength:256', 'Alphanumeric']" :error.sync="errors.companyInput"
            :class="[error.companyInput && model.companyInput == null ? 'warning' : '']" :ref="dataRef.companyInput" />
          </div>
          <div class="busCampaignEditor__content__row">
            <div class="busCampaignEditor__content__row__left">
              <adx-input label="Contact Person *" :value.sync="model.contactInput" :validation="['NotEmpty','NewMinLength:2', 'NewMaxLength:256', 'Alphanumeric']" :error.sync="errors.contactInput"
              :class="[error.contactInput && model.contactInput == null ? 'warning' : '']" :ref="dataRef.contactInput"/>
            </div>
            <div class="busCampaignEditor__content__row__right">
              <adx-input label="Phone Number *" :value.sync="model.phoneInput" :validation="['NotEmpty','NewMinLength:7', 'NewMaxLength:15', 'Phone']" :error.sync="errors.phoneInput"
              :class="[error.phoneInput && model.phoneInput == null ? 'warning' : '']" :ref="dataRef.phoneInput"/>
            </div>
          </div>
        </div>
        <div class="busCampaignEditor__content--section">
          <div class="title subhead">Creative File</div>
          <div class="busCampaignEditor__content__row">
            <ul>
              <li v-for="(file, index) in image" :key="index" class="uploaded">
                <div class="name"><adx-file :file="file"></adx-file></div>
                <div class="delete"><img @click="cancelImage(image, index)" src="/img/adxicon/ic-delete.png" alt=""></div>
              </li>
            </ul>
          </div>
          <div class="busCampaignEditor__content__row">
              <input type="file" accept=".jpg, .jpeg, .png, .zip, .rar, .pdf, .psd, .ai, .eps, .cdr" @change="getFile($event, image)"
              :ref="`fileUpload`" style="display: none;">
            <div class="browse" @click="launchFilePicker">
              <span class="title">Browse file to upload</span>
              <span class="description">Allowed file type zip, rar, pdf, psd, ai, eps, jpg, png, eps and cdr. Maximum size 1GB</span>
            </div>
          </div>
          <div class="busCampaignEditor__content__row">
            <span class="subhead download">Download Bus Design Guide <router-link class="subhead link" to="/">Here</router-link></span>
          </div>
        </div>
        <div class="busCampaignEditor__content--section" v-for="(item, index) in items" :key="index">
          <div class="busCampaignEditor__content__row1">
            <div class="groups">
              <div class="group">
                <span class="subhead route">{{ item.bus.route.title}}</span>
                <span class="subhead placement">{{ item.bus.generic.title }}</span>
              </div>
              <div class="group--type2">
                <div class="smallDropdown">
                   <adx-select-dropdown type="small" :value.sync="item.count" :options="amountOptions" 
                   @selected="selectedValue($event,item, index)"
                   :key="renderer[index]"/>
                </div>
              </div>
            </div>
            <div class="groups">
              <div class="group--type3">
                <div class="priceWrapper">
                  <span class="label">Price</span>
                  <span class="price">{{ item.bus.generic.price * item.count | formatMoney }}</span>
                </div>
              </div>
              <div class="group--type4">
                <div class="imageWrapper">
                  <img @click="deleteItem(items, index)" src="/img/adxicon/ic-delete.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="busCampaignEditor__content--button">
          <button class="btn-small secondary add" @click="addMore">Add More Items</button>
        </div>
      </div>
      <div class="busCampaignEditor__content--right">
        <div class="busCampaignEditor__content--section">
          <div class="subhead title head">Order Summary</div>
          <div class="busCampaignEditor__content__row2">
            <span class="label">Subtotal Price</span>
            <span class="price">{{ getTotalPrice() | formatMoney }}</span>
          </div>
          <div class="busCampaignEditor__content__row2">
            <span class="label">PPN 10%</span>
            <span class="price">{{ getPPN(getTotalPrice()) | formatMoney}}</span>
          </div>
          <div class="busCampaignEditor__content__row2">
            <span class="label">Total Price</span>
          </div>
          <div class="busCampaignEditor__content__row2">
            <span class="large-font totalPrice">{{ getTotalPriceByPPN() | formatMoney}}</span>
          </div>
          <div class="busCampaignEditor__content__row2">
            <div class="button">
            <button v-if="items.length > 0" :disabled="saveLoading" 
              :class="['primary', 'btn-large', 'checkout', saveLoading ? 'disabled' : '']"
              @click="checkout">
              Checkout
              <adx-loading-2 v-if="saveLoading"/>
            </button>
            <button v-else disabled class="btn-large primary uncheckout">Checkout</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- Modal -->
    <adx-modal v-if="isShowModal" title="Order Submitted" type="small">
      <div slot="content" class="busCampaignEditor__modal">
        <div class="busCampaignEditor__modal__top">
          <span>Our team will contact you soon to validate your order</span>
        </div>
        <div class="busCampaignEditor__modal__bottom">
          <button class="btn-regular primary" @click="gotoCampaignDashboard">Campaign Dashboard</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>
</div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import LoadingWhite from '@/components/Loading/Secondary-white';
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import File from '@/components/File'
import Modal from '@/components/Modal'

import * as validationLib from '@/lib/validation/'
import triggerValidation from '@/lib/triggerValidation'

import { parseErrorGql } from '@/lib/error'
import {formatShortDate} from '@/lib/util'
import moment from 'moment'
import { mapGetters } from 'vuex'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-bus-campaign-editor',
  components: {
    'adx-loading': Loading,
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-file': File,
    'adx-modal': Modal,
    'adx-loading-2': LoadingWhite,
  },
  props: {

  },
  data() {
    return {
      count:0,
      countCheckout:0,
      countEdit:0,
      detail: null,
      id: null,
      isInit: true,
      isLoadingAll: false,
      isShowModal: false,
      minimumLeadTime: 0,
      minimumPeriod: 0,
      rendererPeriod: 0,
      saveLoading: false,
      total: 0,
      image: [],
      imageIds:[],
      items: [],
      renderer: [],
      amountOptions: [
        {
          label: "1 Bus",
          value: 1
        },
        {
          label: "2 Bus",
          value: 2
        },
        {
          label: "3 Bus",
          value: 3
        },
        {
          label: "4 Bus",
          value: 4
        },
        {
          label: "5 Bus",
          value: 5
        },
        {
          label: "6 Bus",
          value: 6
        },
        {
          label: "7 Bus",
          value: 7
        },
        {
          label: "8 Bus",
          value: 8
        },
        {
          label: "9 Bus",
          value: 9
        },
        {
          label: "10 Bus",
          value: 10
        },
        {
          label: "11 Bus",
          value: 11
        },
        {
          label: "12 Bus",
          value: 12
        },
        {
          label: "13 Bus",
          value: 13
        },
        {
          label: "14 Bus",
          value: 14
        },
        {
          label: "15 Bus",
          value: 15
        },
        {
          label: "16 Bus",
          value: 16
        },
        {
          label: "17 Bus",
          value: 17
        },
        {
          label: "18 Bus",
          value: 18
        },
        {
          label: "19 Bus",
          value: 19
        },
        {
          label: "20 Bus",
          value: 20
        }
      ],
      periodOptions: [],

      model: {
        id: null,
        campaignInput: null,
        periodDropdown: 1,
        startInput: null,
        companyInput : null,
        contactInput : null,
        phoneInput : null,
      },
      dataRef:{
        campaignInput: "campaignInput",
        periodDropdown: "periodDropdown",
        companyInput: "companyInput",
        contactInput: "contactInput",
        phoneInput: "phoneInput"
      },
      errors: {
        campaignInput: null,
        periodDropdown: null,
        startInput: null,
        companyInput : null,
        contactInput : null,
        phoneInput : null,
      },
      error: {
        companyInput : null,
        contactInput : null,
        phoneInput : null,
      },
    }
  },
  computed: {
    aWeekLater() {
      var aWeekLater = new Date();

      if (this.minimumLeadTime>7){
        aWeekLater.setDate(aWeekLater.getDate() + this.minimumLeadTime);
      } else{
        aWeekLater.setDate(aWeekLater.getDate() + 7);
      }
      return aWeekLater
    },
    ...mapGetters({
      token: 'token'
    }),
  },
  watch: {
    'model.campaignInput': {
      handler: function () {
        (async () => {
          // await this.capitalizeCampaign(this.model.campaignInput)
          await this.capitalizeCampaign()
          this.edit('campaignInput change')
        })();
      },
      deep: true
    },
    'model.periodDropdown': {
      handler: async function (after, before) {
        if (after && before) {
          let minimumPeriod = await this.minimumPeriod
          if(this.model.periodDropdown < minimumPeriod){
            this.model.periodDropdown = await minimumPeriod
            this.rendererPeriod += 1
            await this.errorNotify('Minimum period allowed for this campaign is ' + minimumPeriod + ' months')
          } else{
              this.edit('periodDropdown change')
          }
        }
      },
      deep: true
    },
    'model.startInput':{
      handler: async function (after, before){
        if (after != before){
          let afterday = formatShortDate(after)
          let beforeday = formatShortDate(before)
          if(afterday != beforeday) this.edit('startInput change')
        }
      }
    },
    'model.companyInput': function(){
      this.edit('companyInput change')
    },
    'model.contactInput': function(){
      this.edit('contactInput change')
    },
    'model.phoneInput': function(){
      this.edit('phoneInput change')
    }
  },
  beforeCreate() {

  },
  created() {
    localStorage.setItem('apollo-token', this.token)
    this.id = this.$route.params.id
    const { from } = this.$route.query
    this.getOptions()
    this.isLoadingAll = true
    this.busCampaign()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busCampaign(){
      const  res = await  this.$apollo.query({
        query:require('@/graphql/bus/query/campaignFull.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.id.toString()
        }
      })
      if (res.data){
        if (res.errors){
          this.handleError(res.errors, 'campaign')
        } else{
          const { busCampaign } = await res.data
          if (busCampaign) {
            await this.mapData(busCampaign)
            this.isLoadingAll = false
          }
        }
      }
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'campaign':
              this.count++
              if (this.count<3) {
                await this.busCampaign()
              } else{
                this.errorNotify('Something went wrong. Please refresh the page')
                this.isLoadingAll = false
              }
              break;
            case 'edit':
              this.countEdit++
              if (this.countEdit<3){
                await this.edit('error')
              } else {
                this.errorNotify('Data failed to be saved!')
              }
              break;
            case 'checkout':
              this.countCheckout++
              if (this.countCheckout<3){
                this.errorNotify('Data failed to be saved!')
                this.saveLoading = false
              }
              break;
          }
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async getMinimumPeriod(){
      let minPeriod = 0
      await this.items.forEach(async el =>{
        let minPeriodBus = parseInt(el.bus.generic.minPeriod)
        if(minPeriodBus > minPeriod){
          minPeriod = minPeriodBus
        }
      })
      this.minimumPeriod = minPeriod
    },
    async getMinimumLeadTime(){
      let minLeadTime = 0
      this.items.forEach(el =>{
        let minLeadTimeBus = parseInt(el.bus.generic.leadPreCampaign)
        if(minLeadTimeBus > minLeadTime){
          minLeadTime = minLeadTimeBus
        }
      })
      this.minimumLeadTime = minLeadTime
    },
    selectedValue(event,item, index){
      let minQuantity = item.bus.generic.minQuantity
      // let count = item.count
      let count = event.item.value
      if (minQuantity > count){
        item.count = minQuantity
        let renderVal = this.renderer[index]+1
        this.$set(this.renderer, index, renderVal)
        this.errorNotify('Minimum quantity allowed for this campaign is ' + minQuantity)
      } else{
         if (this.isInit == false){
          item.count = count
          this.edit('selectedValue')
        }

      }
    },
    async mapData(campaign){
      this.model.id = await campaign.id
      this.model.campaignInput = await campaign.title
      this.model.companyInput = await campaign.companyName
      this.model.contactInput = await campaign.contactPerson
      this.model.phoneInput = await campaign.phoneNumber
      this.items = await campaign.orderRoutes
      this.model.startInput = await new Date(campaign.start)
      this.model.periodDropdown = await campaign.period
      let lenOrder = this.items.length
      for (let i = 0; i < lenOrder; ++i) {
          this.renderer[i] = 0;
      }
      await this.getMinimumPeriod()
      await this.getMinimumLeadTime()
      await campaign.content.forEach(async element => {
        await this.image.push({
          name: element.content_url.slice(element.content_url.lastIndexOf("/")+1, element.content_url.length),
          image: null,
          url : element.content_url
        });
        await this.imageIds.push({id:parseInt(element.id)});
      });
      this.isInit = false
      if (this.aWeekLater > this.model.startInput){
        this.model.startInput = this.aWeekLater
      }

      if (this.minimumPeriod > this.model.periodDropdown){
        this.model.periodDropdown = this.minimumPeriod
      }
    },
    getOptions() {
      this.getPeriod()
    },
    getPeriod() {
      let file = `/static/data/monthly_period.json`;
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()

        this.periodOptions = data.periods
      })();
    },
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    getFile(event, image) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0])
        reader.readAsDataURL(input.files[0]);
        (async () => {
          this.image.push({
            name: input.files[0].name,
            image: input.files[0],
            url : null
          })
        })();
        for (let i=0; i<this.image.length; i++){
          reader.onload = (e) => {
          this.image[i].url = e.target.result;
          }
        }
        this.saveFile(input.files[0])
      }
    },
    async saveFile(fileData){
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/uploadFile.gql'),
        errorPolicy: 'all',
        variables: {
          content : {file:fileData}
        },
      });
      this.imageIds.push({id:parseInt(result.data.uploadFile.id)})
      this.edit('saveFile')
    },
    async cancelImage(image, index) {
      image.splice(index, 1)
      this.imageIds.splice(index, 1)
      await this.edit('cancelImage')
    },
    validateFile(file) {
      let maxSize = 1000000000; // 1 GB
      let data = { is_valid: true }
      let ext_patt = new RegExp(/.jpg|.jpeg|.png|.zip|.rar|.pdf|.psd|.ai|.eps|.cdr/)
      if (!ext_patt.test(file.name.toLowerCase())) {
        data.is_valid = false
        data.message = 'Unsupported file type'
        return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File too large.`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 100) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 100 character'
        return data
      }

      if (filename.includes('/')) {
        data.is_valid = false
        data.message = 'File name has forbidden character'
        return data
      }
      return data
    },
    addMore() {
      //mapping data to local storage
      let tempCampaignRoute = []
      this.items.map(el =>{
        let campaignOrder = {
              item_id : parseInt(el.bus.id),
              title: el.bus.route.title,
              media_name: el.bus.generic.title,
              count: el.count,
              category: el.bus.route.category? el.bus.route.category.title : '-',
              price : el.bus.generic.price,
              constraint: {
                minPeriod: el.bus.generic.minPeriod,
                minQuantity: el.bus.generic.minQuantity,
                leadPreCampaign: el.bus.generic.leadPreCampaign,
              }
            }
            tempCampaignRoute.push(campaignOrder)
      })

      // saving data to local storage
      let busData = JSON.stringify({
        selectedOrders : tempCampaignRoute,
        selectedPeriod: this.model.periodDropdown,
        selectedStart: this.model.startInput,
      })
      this.saveToLocal(busData)

      // go to result page
      this.$router.push({ name: 'bus' , params:{id: this.id}})
    },
    async deleteItem(items, index) {
      await items.splice(index, 1)
      await this.renderer.splice(index, 1)
      await this.getMinimumLeadTime()
      await this.getMinimumPeriod()
      await this.edit('deleteItem')
    },
    capitalizeCampaign(){
      this.model.campaignInput = this.model.campaignInput.charAt(0).toUpperCase() + this.model.campaignInput.slice(1)
    },
    validateItemCount(items){
      for (let item of items){
        let minQuantity = item.bus.generic.minQuantity
        if (item.count < item.bus.generic.minQuantity) {
          let route = item.bus.route.title
          let placement = item.bus.generic.title
          this.errorNotify('Minimum quantity allowed for' + route + ` ` + placement + ` is ` + minQuantity )
          return false
        }
      }
      return true
    },
    async checkoutCampaign(){
      if (!this.saveLoading){
      let validation1 = triggerValidation(this.model, this.dataRef, this.$refs, this.errors)
      if (validation1){
        let validateItem = this.validateItemCount(this.items)
        if (validateItem) {
          this.saveLoading = true
          const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/mutation/campaignCheckout.gql'),
            errorPolicy: 'all',
            variables: {
              id: this.model.id,
              checkout:{
                checkout : true,
                totalPrice: this.total.toString(),
              }
            }
          });
          if (result.data){
            if(result.errors){
              this.handleError(result.errors, 'checkout')
            } else{
              this.saveLoading = false
              if (result) {
                this.successNotify('Data successfully saved!')
                  this.showModal()
              } else {
                this.errorNotify(`Data failed to save`)
              }
            }
          }
        }
      }
      }
    },
    async edit(param){
      if (this.isInit == false){
        const date = moment.utc(this.model.startInput).local().format('YYYY-MM-DD')
        let orderRoute = []
        await this.items.forEach(async (value) => {
         await orderRoute.push(
            {
              count: value.count,
              bus: {
                id: parseInt(value.bus.id)
              }
            }
          )
        })
        let validation1 = await triggerValidation(this.errors)

        if (validation1){
          const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/campaignEdit.gql'),
            errorPolicy: 'all',
            variables: {
              id: this.model.id,
              campaign:{
                campaignInfo: {
                  title : this.model.campaignInput,
                  start: date,
                  companyName: this.model.companyInput,
                  contactPerson: this.model.contactInput,
                  phoneNumber: this.model.phoneInput,
                  period: this.model.periodDropdown,
                  content: this.imageIds,
                },
                orderRoutes: orderRoute
              }
            }
          })
          if (result.data){
            if (result.errors){
              this.handleError(result.errors, 'edit')
            }
          }
        }
      }

    },
    showModal() {
      this.isShowModal= !this.isShowModal
    },
    async checkout() {
      await this.checkoutCampaign()
      // this.showModal()
    },
    getTotalPrice(){
      let total = 0
      if (this.items.length > 0){
        this.items.map(x => {
          total += (x.bus.generic.price * x.count) * this.model.periodDropdown
        })
      }
      return total
    },
    getTotalPriceByPPN(){
      return this.getTotalPrice() + this.getPPN(this.getTotalPrice())
    },
    getPPN(value){
      return value / 10
    },
    getTotalPriceCampaign(){
      this.total = Math.round(this.getTotalPrice()) - Math.round(this.getPPN(this.getTotalPrice()))
      return this.total
    },
    gotoCampaignDashboard(){
      this.$router.push({name: 'transactionbus'})
    },
    saveToLocal(data = null){
      let busData = null
      if (data) {
        busData = data
      } else {
        busData = JSON.stringify({...this.getAllOrderData})     
      }
      localStorage.setItem('selectedBusOrder', busData)
    },
    successNotify(message){
      this.$notify({
        group: 'saved',
        title: 'Succes',
        text:  message,
        type: 'success'
      });
    },
    errorNotify(message){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text:  message,
        type: 'danger'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.sk-circle {
  position: absolute !important;
  margin: 0 auto;
}

.busCampaignEditor {
  .popup {
    max-height: 180px;
    overflow-y: auto !important;
  }

  .selectDropdown {
    .select {
      input {
        height: 62px;
      }
    }
  }

  .smallDropdown {
    .selectDropdown {
      .select {
        width: 100px;

        input {
          height: 24px;
          width: 90px;
        }
      }

      .popup {
        max-width: 100px;

        .item {
          padding: 8px 8px;
        }
      }
    }
  }

  .title.large-font {
    font-size: 28px;
  }

  .modal__content__header{
    align-items: center;
    margin-bottom: 8px;
  }

  .modal__content__header{
    button {
      display: none;
    }
  }

  a{
    color: #ff2d55;
  }
}
</style>